<div class="controls-container">
    <div class="controls-header">Form Controls</div>

    <pm-form-panel>
        <pm-form Header="Filter Options"
                 [Request]="Request" 
                 ButtonHorizontalAlignment="Right"
                 CanClear="true"
                 CanCancel="true"
                 (onSubmit)="onSubmit($event)"
                 (onCancel)="onCancel($event)"
                 (onClear)="onClear()"
                 [IsBusy]="IsBusy">
        </pm-form>
    </pm-form-panel>    

</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/form-controls/form-controls.html